var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var internal_exports = {};
__export(internal_exports, {
  Sanitizer: () => import_sanitizer.Sanitizer,
  calculateRetryDelay: () => import_delay.calculateRetryDelay,
  computeSha256Hash: () => import_sha256.computeSha256Hash,
  computeSha256Hmac: () => import_sha256.computeSha256Hmac,
  getRandomIntegerInclusive: () => import_random.getRandomIntegerInclusive,
  isBrowser: () => import_checkEnvironment.isBrowser,
  isBun: () => import_checkEnvironment.isBun,
  isDeno: () => import_checkEnvironment.isDeno,
  isError: () => import_error.isError,
  isNodeLike: () => import_checkEnvironment.isNodeLike,
  isNodeRuntime: () => import_checkEnvironment.isNodeRuntime,
  isObject: () => import_object.isObject,
  isReactNative: () => import_checkEnvironment.isReactNative,
  isWebWorker: () => import_checkEnvironment.isWebWorker,
  randomUUID: () => import_uuidUtils.randomUUID,
  stringToUint8Array: () => import_bytesEncoding.stringToUint8Array,
  uint8ArrayToString: () => import_bytesEncoding.uint8ArrayToString
});
module.exports = __toCommonJS(internal_exports);
var import_delay = require("./delay.js");
var import_random = require("./random.js");
var import_object = require("./object.js");
var import_error = require("./error.js");
var import_sha256 = require("./sha256.js");
var import_uuidUtils = require("./uuidUtils.js");
var import_checkEnvironment = require("./checkEnvironment.js");
var import_bytesEncoding = require("./bytesEncoding.js");
var import_sanitizer = require("./sanitizer.js");
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Sanitizer,
  calculateRetryDelay,
  computeSha256Hash,
  computeSha256Hmac,
  getRandomIntegerInclusive,
  isBrowser,
  isBun,
  isDeno,
  isError,
  isNodeLike,
  isNodeRuntime,
  isObject,
  isReactNative,
  isWebWorker,
  randomUUID,
  stringToUint8Array,
  uint8ArrayToString
});
